module.exports = __webpack_public_path__ + "static/media/approve.ba147e39.svg";